import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError, Observable } from 'rxjs';

import {
  LoacationPagination,
  Location,
  LocationCreateReq,
  LocationEditReq,
  LocationNamesResp,
} from 'src/app/models/user/location.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  constructor(private http: HttpClient) {}

  public searchLocationService(
    idCompany: string,
    search: string,
    pageNumber: number,
    pageSize: number
  ) {
    return this.http.get<LoacationPagination>(
      `${environment.apis.location.SEARCH}`,
      {
        params: {
          idCompany,
          search,
          pageNumber,
          pageSize,
        },
      }
    );
  }

  public getLocationNamesService(
    idCompany: string
  ) {
    return this.http.get<LocationNamesResp[]>(
      `${environment.apis.location.LIST_NAMES}/${idCompany}`
    );
  }

  public searchIdLocation(id: string) {
    return this.http.get<Location>(
      `${environment.apis.location.GET}/${id}`
    );
  }

  public updateLocation(location: LocationEditReq) {
    return this.http.put<Location>(
      `${environment.apis.location.PUT}`,
      location
    );
  }

  public createLocation(location: LocationCreateReq): Observable<Location> {
    return this.http.post<Location>(
      `${environment.apis.location.POST}`,
      location
    );
  }
}
